import moment from "moment";

export default class XPAYReportOperation {
  operationData;
  constructor(operation) {
    this.operationData = operation;
  }

  get dateTime() {
    const _dateTimeObj = moment(this.operationData.DateTime);
    return {
      date: _dateTimeObj.format("DD.MM.YYY"),
      time: _dateTimeObj.format("HH:mm:ss"),
    };
  }

  get amount() {
    return (parseInt(this.operationData.Sum) / 100).toFixed(2);
  }

  get status() {
    return this.operationData.Status;
  }

  get posData() {
    try {
      return JSON.parse(this.operationData?.POS_DATA);
    } catch {
      return {};
    }
  }
}
